export default "__VITE_ASSET__DFbdT1X2__"